// src/screens/catalogUpload/CatUpload.tsx
import React from 'react'
import classes from './CatUpload.module.sass'
import { Helmet } from 'react-helmet-async'
import { List } from './components/list/List'
import { Modal } from '../../../common/components/modal/Modal'
import { Form } from './components/form/Form'
import { Details } from './components/details/Details'
import { useCatUpload } from './useCatUpload'
import Search from '../../../common/components/listControl/search/Search'
import { useSearchWithDebounce } from '../../../common/hooks/useSearchWithDebounce'
import { Button } from '../../../common/components/button/Button'

export const CatUpload = () => {
  const {
    getList,
    modalActive,
    setModalActive,
    startEdit,
    edit,
    data,
    setData,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    initialData,
    startCreate,
    loading,
  } = useCatUpload()

  const {
    searchQuery,
    handleSearch,
    clearSearch,
    filteredItems: filteredList,
  } = useSearchWithDebounce({
    items: list,
    searchFields: ['fileName', 'status', 'clusterId'],
  })

  return (
    <div className={classes.container}>
      <Helmet>
        <title>{`Импорт каталога`}</title>
        <meta name="description" content={`Импорт каталога`} />
      </Helmet>
      <div className={classes.titleWithButtons}>
        <div className={classes.header}>{`импорт каталога`}</div>
        <Button onClick={startCreate} text="Загрузить" />
      </div>
      <div className={classes.searchContainer}>
        <Search
          onChange={handleSearch}
          clear={clearSearch}
          value={searchQuery}
          placeHolder="Поиск по файлу, статусу или ID"
        />
      </div>
      <List showDetails={showDetails} startEdit={startEdit} list={filteredList} loading={loading} />
      <Modal modalActive={modalActive} setModalActive={setModalActive}>
        <Form
          edit={edit}
          data={data}
          setData={setData}
          getList={getList}
          setModalActive={setModalActive}
          el={current}
          initialData={initialData}
          modalActive={modalActive}
        />
      </Modal>
      <Modal modalActive={detailsModalActive} setModalActive={setDetailsModalActive}>
        <Details el={current} />
      </Modal>
    </div>
  )
}
